import type { ReactElement } from 'react'
import type { Refinement } from 'react-instantsearch-core'

import { normalizeRangeInputValue } from 'shared/utils/algolia/filters'
import { currencyToSymbol } from 'views/components/atoms/Price/helpers'
import StarRating from 'views/components/molecules/StarRating'

export type ExtendedRefinement = Refinement & {
  currentRefinement: { min: number; max: number }
}

export const currentRefinementAccessorGetPriceLabel = (
  refinement: ExtendedRefinement,
  currency: string
): string => {
  const { min, max } = refinement.currentRefinement
  const currencySymbol = currencyToSymbol(currency)

  return `${
    Math.round(normalizeRangeInputValue(min)) / 100
  } ${currencySymbol} - ${
    Math.round(normalizeRangeInputValue(max)) / 100
  } ${currencySymbol}`
}

export const currentRefinementAccessorGetCategoryLabel = (
  refinement: ExtendedRefinement
) => {
  const categories = refinement.label.split('/')
  const lastCategory = categories[categories.length - 1]
  if (lastCategory) {
    return lastCategory
  }

  return refinement.label
}

export const currentRefinementAccessorGetRatingLabel = (
  refinement: ExtendedRefinement
): ReactElement => {
  return (
    <div className="l-flex">
      <StarRating
        rating={refinement.currentRefinement.min}
        iconSize="x-small"
        alignToEnd
        hasSuperScript={false}
      />
      <span className="u-padding-x-small--sides">-</span>
      <StarRating
        rating={refinement.currentRefinement.max}
        iconSize="x-small"
        alignToEnd
        hasSuperScript={false}
      />
    </div>
  )
}

export const currentRefinementAccessorGetRefinementLabel = (
  refinement: ExtendedRefinement,
  currency: string
): ReactElement | string => {
  switch (refinement.attribute) {
    case 'price':
      return currentRefinementAccessorGetPriceLabel(refinement, currency)
    case 'primaryCategory':
      return currentRefinementAccessorGetCategoryLabel(refinement)
    case 'averageRating':
      return currentRefinementAccessorGetRatingLabel(refinement)
    default:
      return refinement.label
  }
}
